import React from 'react'
import FilterButton from './FilterButton';
import OptionButton from './OptionButton';


export default function SearchPanelFilterFukui(props) {
    const anchorRef = React.useRef(null);
    
    function getDisabled(type){
        //未選択
        if(props.filters.type.length === 0){
            return false;
        }else{
            
            var isPhoto = props.filters.type.includes("photo");
            var isOther = props.filters.type.some((item) => item !== "photo")

            //撮影日時
            if(type === "filmingDateTime"){
                return !isPhoto;
            }else
            //その他
            {
                return !isOther;
            }
        }
    }

    return (
        <div className={"searchpanel-collapsed " + (props.searchPanelVisible ? "searchpanel-visible" : "")}>
                        
            <div ref={anchorRef} className="searchpopupshow" />

            <div className="searchfilters">
                <FilterButton label="対象"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}
                    
                    isDisabled={false}
                    isShow={true}

                    isFacilityType={true}
                    popupKind={'list'}
                    filterKind={'type'}
                    targetTypes={props.filters.type}
                />

                <FilterButton label={"分類"}
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onClick={props.onSearchFilterClick}
                    onApplyFilter={props.onApplyFilter}
                    
                    isDisabled={getDisabled("primaryCategory")}
                    isShow={!getDisabled("primaryCategory") || props.filters.primaryCategory.length !== 0}

                    popupKind={'list'}
                    filterKind={'primaryCategory'}
                    targetTypes={props.filters.primaryCategory}
                />

                <FilterButton label={"管理事務所"}
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}

                    isDisabled={getDisabled("componentManagerOffice")}
                    isShow={!getDisabled("componentManagerOffice") || props.filters.componentManagerOffice.length !== 0}

                    popupKind={'list'}
                    filterKind={'componentManagerOffice'}
                    targetTypes={props.filters.componentManagerOffice}
            />

                <FilterButton label="健全度"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}
                    
                    isDisabled={getDisabled("overallHealthLevel")}
                    isShow={!getDisabled("overallHealthLevel") || props.filters.overallHealthLevel.length !== 0}

                    popupKind={'list'}
                    filterKind={'overallHealthLevel'}
                    targetTypes={props.filters.overallHealthLevel}
                />
                
                <FilterButton label="写真撮影日"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    onApplyFilter_date={props.onApplyFilter_date}
                    onClick={props.onSearchFilterClick}

                    isDisabled={getDisabled("filmingDateTime")}
                    isShow={!getDisabled("filmingDateTime") || props.filters.filmingDateTime_str.length !== 0 || props.filters.filmingDateTime_end.length !== 0}

                    popupKind={'date'}
                    filterKind={'filmingDateTime'}
                    filterKind_str={"filmingDateTime_str"}
                    filterKind_end={"filmingDateTime_end"}
                    DateTime_str={props.filters.filmingDateTime_str}
                    DateTime_end={props.filters.filmingDateTime_end}
                />

                <OptionButton label="オプション" onClick={props.onSearchOptionClick} />
            </div>
        </div>
    );

}
